export function tab() {
    document.addEventListener('DOMContentLoaded', function () {
        const tabs = document.querySelectorAll('.p-interview-info__tab a');
        const areas = document.querySelectorAll('.p-interview-info__area');

        function activateTab(tab) {
            tabs.forEach(t => t.parentNode.classList.remove('active'));
            areas.forEach(area => area.classList.remove('is-active'));

            tab.parentNode.classList.add('active');
            const activeArea = document.querySelector(tab.getAttribute('href'));
            if (activeArea) {
                activeArea.classList.add('is-active');
            }
        }

        function switchTab(e) {
            e.preventDefault();
            activateTab(this);
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', switchTab);
        });

        // 最初のタブをアクティブにする（URLにハッシュがない場合）
        if (!window.location.hash && tabs.length > 0) {
            activateTab(tabs[0]);
        } else {
            // URLのハッシュに対応するタブをアクティブにする
            const activeTab = Array.from(tabs).find(tab => tab.getAttribute('href') === window.location.hash);
            if (activeTab) {
                activateTab(activeTab);
            }
        }
    });

}
